










import { Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import BaseMixin from '../../mixins/BaseMixin';
import _ from 'lodash/fp';
import { CarPartsModuleTypes } from '@/store/modules/car-parts';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import SearchablePartsList from '@/components/part-search/SearchablePartsList.vue';
import { localize } from '../../filters/localize';

@Component({
    components: {
        SearchablePartsList,
    },
})
export default class AvailablePartsList extends Mixins(BaseMixin) {
    @Prop(String)
    private carTitle!: string;
    @Prop(Array)
    private partNumbers!: string[];
    @Prop(String)
    private brandCode!: string;
    @Prop(String)
    private partActionLink!: string;

    private allParts: PartSearchResultDetails[] = [];
    private filteredParts: PartSearchResultDetails[] = [];

    public get partsOfCar(): PartSearchResultDetails[] {
        return this.$store.getters[CarPartsModuleTypes.getters.parts];
    }

    public get loadingState(): LoadingState {
        return this.$store.getters[CarPartsModuleTypes.getters.carPartsLoadingState];
    }

    public get searchBoxTitle(): string {
        return `${localize(this.l10n.CAR.AVAILABLE_PARTS_TITLE)} ${this.carTitle}`;
    }

    public mounted(): void {
        this.$store.dispatch(CarPartsModuleTypes.actions.loadPartsOfCar, {
            partNumbers: this.partNumbers,
            brand: this.brandCode,
        });
    }

    private onSearchTextChanged(searchTerm: string): void {
        this.filterParts(searchTerm);
    }

    private filterParts(searchTerm: string): void {
        if (searchTerm === '') {
            this.filteredParts = this.partsOfCar;
        } else {
            const lowersearchTerm = searchTerm.toLowerCase();
            this.filteredParts = this.partsOfCar.filter(
                (part) =>
                    part.searchResult.name.toLowerCase().includes(lowersearchTerm) ||
                    part.searchResult.partNumber.toLowerCase().includes(lowersearchTerm)
            );
        }

        this.allParts = this.partsOfCar;
    }

    @Watch('loadingState')
    private onLoadingStateChanged(): void {
        if (this.loadingState === LoadingState.Loaded) {
            this.allParts = this.partsOfCar;
            this.filteredParts = this.partsOfCar;
        }
    }
}
